import { render, staticRenderFns } from "./userProfileAvatar.vue?vue&type=template&id=3696510f&"
import script from "./userProfileAvatar.vue?vue&type=script&lang=js&"
export * from "./userProfileAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports